import $ from 'jquery';
import { frame } from '../../utils/drawing';
import { directiveSettings } from '../../utils/parse';

export class DottedTriangle {

	constructor(settings={}) {
		this.width = settings.width;
		this.height = settings.height;
		this.direction = settings.direction;
		this.radius = settings.radius;
		this.delta = settings.delta;
		this.random = settings.random;

		this.$element = $(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
		this.$element.attr('width', this.width + this.radius * 2);
		this.$element.attr('height', this.height + this.radius * 2);
		this.$element[0].setAttribute('viewBox', [
			-this.radius,
			-this.radius,
			this.width + this.radius,
			this.height + this.radius,
		].join(' '));

		this.draw();
	}

	draw() {
		this.$element.children().remove();
		this._dots = [];

		for (let x = 0; x < this.width; x += this.delta) {
			let rx = (x / this.width);
			if (this.direction === 'right') {
				rx = 1 - rx;
			}
			const dh = rx * this.height;
			const offset = (this.height - dh) / 2;
			const shift = (x % (this.delta * 2)) / 2;

			for (let y = offset + shift; y < offset + dh; y += this.delta) {
				const accept = Math.abs((y - offset) / dh - 0.5) * 2;
				const $dot = this.createDot(x, y);

				this._dots.push({ x, y, accept, $dot });

				this.$element.append($dot);
			}
		}
	}

	randomize() {
		for(let { x, y, accept, $dot } of this._dots) {
			$dot.toggleClass('is-visible', accept * this.random < Math.random())
		}
	}

	createDot(x, y) {
		const $dot = $(document.createElementNS('http://www.w3.org/2000/svg', 'circle'));
		$dot.attr('cx', x);
		$dot.attr('cy', y);
		$dot.attr('r', this.radius);

		return $dot;
	}
}

export default function dottedTriangleDirective(context=document.body) {
	const $context = $(context);
	const $dottedTriangles = $context.find('[sw-dotted-triangle]');

	$dottedTriangles.each(function() {
		const $element = $(this);
		const json = $element.attr('sw-dotted-triangle');
		const settings = directiveSettings(json, {
			width: 680,
			height: 280,
			direction: 'right',
			radius: 4,
			delta: 32,
			interval: 500,
			random: 0.75,
		}, 'direction');

		const dottedTriangle = new DottedTriangle(settings);

		$element.append(dottedTriangle.$element);

		setInterval(() => frame(() => dottedTriangle.randomize()), settings.interval);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/dotted-triangle.js